import { ReviewChatRooms } from "../Model/companyReviewsObjects";
import { REVIEW_CHAT_ROOMS } from "../Reducers/reviewChatRoomsReducer";
import { fetchReviewChatRooms } from "../Util/queries";
    

export const getReviewChatRooms = ({orderIds, reviewIds}) => async (dispatch) => {
    try {
        const data = {
            orderIds: orderIds,
            reviewIds: reviewIds
        }
        const response = await fetchReviewChatRooms(data);
        dispatch({
            type: REVIEW_CHAT_ROOMS,
            payload: new ReviewChatRooms(response.data, orderIds, reviewIds)
        });
    } catch (error) {
        console.error(error);
        dispatch({
            type: REVIEW_CHAT_ROOMS,
            payload: new ReviewChatRooms({}, orderIds, reviewIds)
        });
    }
}; 
